import React from "react";
import EditButton from "./Buttons/EditButton";
import { Box, Modal } from "@mui/material";
import { useState } from "react";
import EditRole from "./forms/EditRole";
import DeleteButtonUserData from "./Buttons/DeleteButtonUserData";
import DeleteUserModal from "./Notes/DeleteUserModal";
import { getRoleColor } from "../utils/roleColors";

function FormLineMedium5(props) {
  const roleColor = getRoleColor(props.userRole);

  const styleDeleteModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 390,
    maxWidth: "calc(100vw - 32px)",
    borderRadius: "8px",
    overflow: "hidden",
    bgcolor: "background.paper",
    /*border: "1px solid #000",*/
    boxShadow: "0 22px 60px rgba(14, 25, 45, 0.24)",
    // p: 4,
  };

  const styleModalGeneral = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 430,
    maxWidth: "calc(100vw - 32px)",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "white",
    boxShadow: "0 22px 60px rgba(14, 25, 45, 0.24)",
  };

  const [openEditRole, setOpenEditRole] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleOpenEditRole = () => setOpenEditRole(true);
  const handleCloseEditRole = () => setOpenEditRole(false);

  const openDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  return (
    <div className="roles-table-row">
      <Modal
        open={openEditRole}
        onClose={handleCloseEditRole}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <EditRole
            closemodal={handleCloseEditRole}
            userName={props.userName}
            roleUser={props.userRole}
            userId={props.userId}
          />
        </Box>
      </Modal>
      <Modal
        open={showDeleteModal}
        onClose={closeDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDeleteModal}>
          <DeleteUserModal
            onClose={closeDeleteModal}
            uid={props.userId}
            userName={props.userName}
            userEmail={props.userEmail}
          />
        </Box>
      </Modal>
      <div className="roles-col roles-col-email">{props.userEmail}</div>
      <div className="roles-col roles-col-name">{props.userName}</div>
      <div className="roles-col roles-col-role">
        <span
          className="roles-role-pill"
          style={{ background: roleColor, borderColor: roleColor }}
        >
          {props.userRole || "No role"}
        </span>
      </div>
      <div className="roles-col roles-col-phone">{props.userPhone || "-"}</div>

      <div className="roles-col roles-col-actions">
        <div className="roles-row-actions">
          <EditButton title="Edit" handleOpen={handleOpenEditRole} />
          <DeleteButtonUserData
            handleOpen={openDeleteModal}
            closeModal={closeDeleteModal}
          />
        </div>
      </div>
    </div>
  );
}

export default FormLineMedium5;
